import { render } from "./PlanoMesas.vue?vue&type=template&id=403bbafc&scoped=true"
import script from "./PlanoMesas.vue?vue&type=script&lang=js"
export * from "./PlanoMesas.vue?vue&type=script&lang=js"

import "./PlanoMesas.vue?vue&type=style&index=0&id=403bbafc&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\frontend_restaurante\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-403bbafc"]])

export default __exports__